export default __webpack_public_path__ + "static/media/calender_ico.dd669e89.svg";